import bgImage from "../../Assets/AIOnDemand/hi-bg.png";
import image from "../../Assets/AIOnDemand/hi-image.png";
const HumanIntelligence = () => {
    return (
        <section
            className="w-full bg-cover overflow-hidden relative lg:mb-10"
            style={{
                backgroundImage: `url(${bgImage})`,
            }}
        >
            <div className="w-full gap-16 h-full max-w-[1500px] mx-auto px-4 pt-8 md:pt-20 flex flex-col justify-between items-center">
                <div>
                    <h2 className="text-3xl md:text-5xl lg:text-7xl  text-black font-semibold text-center flex items-start justify-center">
                        AI + Human Intelligence (HI)
                    </h2>
                    <h4 className="text-center w-[75%] mx-auto md:mx-auto  md:w-fit text-black md:text-2xl mt-6">
                        Let your team do its best work.
                    </h4>
                </div>
                <div
                    className="w-full h-auto mt-auto max-w-[1200px]"
                >
                    <img src={image} alt="" width="100%" height="100%" loading="lazy" className="w-full h-full object-contain" />
                </div>
            </div>
        </section>
    );
}

export default HumanIntelligence;